import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Container, TextField } from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import { useAlert } from "../../components/Alert";
import GenericButton from "../../components/Custom/GenericButton";
import api from "../../globals/axios";

const CreateStage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { programId } = useParams();
  const { showAlert } = useAlert();
  const [formData, setFormData] = useState({
    name: "",
    start_day: "",
    end_day: "",
    program: programId || "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post(
        "/farm-activities/create-stage/",
        formData
      );
      showAlert("success", t("Stage created successfully"));
      navigate(
        `/pop-manager/program/${programId}/stage/${data.data.id}/create-activity/`
      );
    } catch (error) {
      showAlert("error", t("Failed to create stage"));
      console.error("Error creating stage:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Container
      maxWidth="xs"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <CustomTitle>{t("Create Stage")}</CustomTitle>
      <form
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
        onSubmit={handleSubmit}
      >
        <TextField
          label={t("Stage Name")}
          variant="outlined"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          placeholder={t("Enter stage name")}
          required
        />
        <TextField
          label={t("Start Day")}
          type="number"
          name="start_day"
          value={formData.start_day}
          onChange={handleChange}
          required
        />
        <TextField
          label={t("End Day")}
          type="number"
          name="end_day"
          value={formData.end_day}
          onChange={handleChange}
          required
        />
        <GenericButton
          type="submit"
          backgroundColor="primary"
          fontColor="#fff"
          padding="10px"
        >
          {t("Submit")}
        </GenericButton>
      </form>
    </Container>
  );
};

export default CreateStage;
